// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-option[data-v-37124d20]{align-items:center;background:#f8f9fa;border-radius:4px;color:#495057;display:flex;gap:4px;height:32px;justify-content:center;padding:8px;white-space:nowrap;width:-moz-fit-content;width:fit-content}.filter-option .close-button[data-v-37124d20]{background:transparent;display:flex;padding:initial}.filter-option .close-button .gi[data-v-37124d20]{color:#868e96}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
